import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

import {API_URL} from './token.service';

import 'rxjs/add/operator/filter';

@Injectable()
export class _SettingsService{

  constructor(private http: HttpClient){ }

  GetMinimumOrderQuantities(){
    return this.http.get(`${API_URL}/minimum-order-quantities`)
  }

  CreateMinimumOrderQuantity(minimumOrderQuantity){
    return this.http.post(`${API_URL}/minimum-order-quantities`, [ minimumOrderQuantity ]);
  }

  UpdateMinimumOrderQuantity(minimumOrderQuantity){
    return this.http.put(`${API_URL}/minimum-order-quantities`, [ minimumOrderQuantity ]);
  }

  DeleteMinimumOrderQuantity(minimumOrderQuantityId){
    return this.http.delete(`${API_URL}/minimum-order-quantities/` + minimumOrderQuantityId);
  }

  GetSecurityQuantityRatios(){
    return this.http.get(`${API_URL}/asset-quantity-ratios`)
  }

  CreateSecurityQuantityRatio(securityQuantityRatio){
    return this.http.post(`${API_URL}/asset-quantity-ratios`, [ securityQuantityRatio ]);
  }

  UpdateSecurityQuantityRatio(securityQuantityRatio){
    return this.http.put(`${API_URL}/asset-quantity-ratios`, [ securityQuantityRatio ]);
  }

  DeleteSecurityQuantityRatio(securityQuantityRatioId){
    return this.http.delete(`${API_URL}/asset-quantity-ratios/` + securityQuantityRatioId);
  }
}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/services/settings.service.ts